import VueRouter from "vue-router";
import routes from "./routes";

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkExactActiveClass: "active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});


router.beforeEach((to, from, next) => {
  if (to.name == 'token') {  next() }
  else {
    if (localStorage["user_jwt"]) {
      if (to.path == '/login') {
        next('/');
      } else next()
    } else {
      //prevent loop
      if (to.path == '/login') return next();
      next('/login')
    }
  }
});

export default router;
